import React, { useEffect, useState } from 'react'
import './style/carousel.css'
import './style/index.css'
import api from '../../uitil/api'
import { encode } from 'js-base64'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay, Pagination } from 'swiper'
export default function Carousels() {
  const [list, setList] = useState([])
  //请求接口数据

  const security = async (homeApi) => {
    await api.get(`${homeApi}`).then((data) => {
      setList(data)
    })
  }
  //初始化调用一次
  useEffect(() => {
    security('swiper')
  }, [])
  return (
    <div className="asd">
      <Swiper
        className="swiper"
        spaceBetween={50}
        modules={[Autoplay, Navigation, Pagination]}
        autoplay={{ delay: 2000 }}
        navigation
        loop
        pagination={{ clickable: true }}>
        {list.map((item, index) => (
          <SwiperSlide
            key={index}
            onClick={() => {
              window.open(
                `/#/home/${item.id}?item=${encode(JSON.stringify(item.item))}`,
                '_blank'
              )
            }}>
            <img src={item.image_url} alt="" />{' '}                                                                                
          </SwiperSlide>
        ))}
        <div className="swiper-pagination"></div>
      </Swiper>
    </div>
  )
}
